import type { LocalizedString } from '@/services/dto';
import type { PoiContentSlide } from '@/types/shop';

const resolveLocalizedValue = (value: LocalizedString | string | undefined, language: string): string => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value[language] || value['ko'] || '';
};

export const isMinimalPoiSlide = (poiContentSlide: PoiContentSlide | null | undefined, language: string): boolean => {
    const ptypeSmall = poiContentSlide?.data?.contents?.popupTypeSmall;
    return resolveLocalizedValue(ptypeSmall, language).trim().toLowerCase() === 'y';
};
